<div class="wrapper">
  <app-resp-popup-title>
    @if (state === "new") {
      <ng-container i18n="@@FormularEditorArtikelAddRowPopupTitle">
        Add New Item
      </ng-container>
    } @else {
      <ng-container i18n="@@FormularEditorArtikelEditRowPopupTitle">
        Edit Item
      </ng-container>
    }
  </app-resp-popup-title>
  <app-resp-popup-content>
    <form [formGroup]="form">
      <div class="inputs-container">
        <div id="input-name">
          <frm-planung-resource-select
            [multiselect]="false"
            [onlyUsers]="true"
            formControlName="name"
            [allowNone]="false"
          >
          </frm-planung-resource-select>
        </div>

        <div id="input-datum br">
          <frm-date-picker
            formControlName="datum"
            label="Datum"
            normalize="start_of_day"
          ></frm-date-picker>
        </div>

        <div class="grid br">
          <div id="input-zuschlag">
            <frm-text
              type="number"
              formControlName="zuschlag"
              [label]="'Zuschlag'"
            ></frm-text>
          </div>

          <div id="input-zone">
            <frm-text
              formControlName="zone"
              type="number"
              [label]="'Zone'"
            ></frm-text>
          </div>
        </div>

        <div class="grid br">
          <div id="input-arbeitszeitbeginn">
            <frm-time-picker
              formControlName="arbeitszeitbeginn"
              interval="5min"
              min="00:00"
              max="24:00"
              label="Beginn"
            ></frm-time-picker>
          </div>

          <div id="input-arbeitszeit">
            <frm-time-picker
              formControlName="arbeitszeit"
              interval="5min"
              min="00:00"
              max="24:00"
              label="Arbeitszeit"
              mode="timeSpan"
            ></frm-time-picker>
          </div>

          <div id="input-arbeitszeitende">
            <frm-time-picker
              formControlName="arbeitszeitende"
              interval="5min"
              min="00:00"
              max="24:00"
              label="Ende"
            ></frm-time-picker>
          </div>

          <div id="input-fahrtzeit">
            <frm-time-picker
              formControlName="fahrtzeit"
              interval="5min"
              min="00:00"
              max="24:00"
              label="Fahrtzeit"
              mode="timeSpan"
            ></frm-time-picker>
          </div>
        </div>

        <div id="input-gesamtzeit">
          <frm-time-picker
            formControlName="gesamtzeit"
            interval="5min"
            min="00:00"
            max="24:00"
            label="Gesamtzeit"
            mode="timeSpan"
          ></frm-time-picker>
        </div>
      </div>
    </form>
  </app-resp-popup-content>
  <app-resp-popup-actions>
    <div>
      <div>
        <ng-container>
          <ctrl-btn-accept
            (click)="onAccept()"
            [disabled]="!canAccept"
          ></ctrl-btn-accept>
        </ng-container>
        <ng-container>
          <ctrl-btn-cancel (click)="onCancel()"></ctrl-btn-cancel>
        </ng-container>
      </div>
    </div>
  </app-resp-popup-actions>
</div>
